import { ReactComponent as RefreshIcon } from './refresh.svg'

export default RefreshIcon
